<div class="catalog-content">
  <form
    name="form"
    (ngSubmit)="f.form.valid && proceesData()"
    #f="ngForm"
    novalidate
  >
    <div class="row">
      <div class="col-md-6">
        <div class="form-group padding-right-10">
          <mat-form-field>
            <mat-select
              placeholder="Section"
              [(ngModel)]="selectedSelection"
              name="section"
              #section="ngModel"
              required
              (selectionChange)="onSelectionChange($event)"
            >
              <mat-option *ngFor="let item of sectionList" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      </div>

      <!--UPLOAD URL FOR CEO-BANNER-->
      <div class="col-md-6" *ngIf="selectedSelection === 'Banners for CEO'">
        <div class="form-group padding-right-10">
          <mat-form-field>
            <input
              type="url"
              matInput
              placeholder="URL"
              [(ngModel)]="urlSelection"
              name="url"
              #url="ngModel"
            />
            <mat-error *ngIf="url.invalid"
            >Invalid URL</mat-error
          >
          </mat-form-field>
      </div>
      </div>

      <!--UPLOAD URL FOR INVESTOR NFO-BANNER SOURCE-->
      <div class="col-md-6" *ngIf="selectedSelection === 'Banners for Investor NFO'">
        <div class="form-group padding-right-10">
          <mat-form-field>
            <mat-select
              placeholder="Select Source"
              [(ngModel)]="selectedSource"
              name="source"
              #source="ngModel"
              (selectionChange)="onSourceChange($event)"
            >
              <mat-option
                *ngFor="let source of sourceList"
                [value]="source?.value"
              >
                {{ source?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <!-- SCHEME: SECTION === BANNER -->
          <mat-form-field *ngIf="selectedSelection === 'Banners for Product'">
            <mat-select
              placeholder="Scheme"
              [(ngModel)]="selecteScheme"
              name="Scheme"
              #scheme="ngModel"
            >
              <mat-option
                *ngFor="let scheme of schemeList"
                [value]="scheme.schemeCode"
              >
                {{ scheme?.schemeName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.submitted && scheme.invalid"
              >Scheme is required</mat-error
            >
          </mat-form-field>
          <!-- Fund Manager: SECTION === FUND_MANAGER -->
          <mat-form-field *ngIf="selectedSelection === 'Fund managers'">
            <mat-select
              placeholder="Fund Manager"
              [(ngModel)]="selectedFundManger"
              name="fundManager"
              #fundManager="ngModel"
              required
            >
              <mat-option
                *ngFor="let fmanager of fundManagerList"
                [value]="fmanager.names"
              >
                {{ fmanager?.names }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
          <!-- Feature: SECTION === KEY_FEATURES -->
          <mat-form-field *ngIf="selectedSelection === 'Key features'">
            <mat-select
              placeholder="Feature"
              [(ngModel)]="selectedFeature"
              name="feature"
              #feature="ngModel"
              required
            >
              <mat-option
                *ngFor="let feature of keyFeatureList"
                [value]="feature.names"
              >
                {{ feature?.names }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Feature: SECTION === INVESTMENT_APPROACH -->
          <mat-form-field *ngIf="selectedSelection === 'Investment Approach'">
            <mat-select
              placeholder="Investment Approach"
              [(ngModel)]="selectedFeature"
              name="investment"
              #investment="ngModel"
              required
            >
              <mat-option
                *ngFor="let investment of investmentApproachList"
                [value]="investment.names"
              >
                {{ investment?.names }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="form-group">
      <app-file-input
        (fileChange)="onFileChange($event)"
        [(ngModel)]="fileName"
        name="fileName"
        placeholder="Upload Image"
        required="true"
      >
        <button type="button" mat-raised-button color="primary">Choose</button>
      </app-file-input>
      <ng-template [ngIf]="selectedSelection === 'Banners for Product' || selectedSelection === 'Banners for NFO' || selectedSelection === 'Banners for CEO' || selectedSelection === 'Banners for Careers'">
      <p>Note: Please upload image with resolution 1920*515</p>
    </ng-template>
    <ng-template [ngIf]="selectedSelection === 'Banners for Investor NFO' && selectedSource === 'M'">
      <p>Note: Please upload image with resolution 325*300</p>
    </ng-template>
    </div>
    <div class="margin-top-20 text-center">
      <button
        mat-raised-button
        color="primary"
        class="mat-button-large"
        type="submit"
        [disabled]="!f.valid"
      >
        Submit
      </button>
    </div>
  </form>
  <app-banner-list
    [data]="bannerList"
    [selection]="selectedSelection"
    *ngIf="
      selectedSelection === 'Banners for Product' ||
      selectedSelection === 'Banners for NFO' ||
      selectedSelection === 'Banners for CEO' ||
      selectedSelection === 'Banners for Careers' ||
      selectedSelection === 'Banners for LTEF' ||
      selectedSelection === 'Banners for Investor NFO'
    "
  ></app-banner-list>
  <app-fund-manager-images
    [data]="fundManagerList"
    *ngIf="selectedSelection === 'Fund managers'"
  ></app-fund-manager-images>
  <app-key-features
    [data]="keyFeatureList"
    *ngIf="selectedSelection === 'Key features'"
  ></app-key-features>
  <app-investment-approach  
  [data]="investmentApproachList"
  *ngIf="selectedSelection === 'Investment Approach'">
</app-investment-approach>
</div>
